import './scss/style.scss';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/tab';
import './js/base_js/wk_ui';
window.wk_ui.helper.setTabColor();
window.wk_ui.roundedTabs.enable();
